// export const ANAHEX_BE_HOST_NAME = 'http://localhost:8089/anahex-prod-e748e/asia-south1/api'

// export const ANAHEX_BE_HOST_NAME = 'https://kalam.anahex.com/api'

export const ANAHEX_BE_HOST_NAME = 'https://api-e6nfj4ax7a-el.a.run.app'